import {
  createManagedTemplate,
  getManagedTemplateBySource,
  importSourceTemplate,
  templateDownloadUrl,
} from "./api";
import { createSingleFlight } from "./templateSourceRecovery";

const runSourceImport = createSingleFlight();

function cleanTemplateName(fileName = "") {
  return String(fileName).replace(/\.(docx?|pdf|html?)$/i, "").replace(/_\d{12,}$/g, "").trim();
}

async function recoverExistingTemplate(sourceDocumentId, originalError) {
  try {
    const existing = await getManagedTemplateBySource(sourceDocumentId);
    if (existing?.id) return { templateId: existing.id, recoveredExisting: true };
  } catch {
    // 保留原始创建错误，避免回查失败掩盖真正原因。
  }
  throw originalError;
}

async function performEditableSourceImport(file) {
  const sourceDocumentId = file.sourceRecordId || file.id;
  try {
    return await importSourceTemplate(sourceDocumentId, {
      requiresElectronicSignature: file.requiresElectronicSignature !== false,
    });
  } catch (error) {
    if (error.status !== 404 || !file.filePath) throw error;
  }

  const response = await fetch(templateDownloadUrl(file.filePath), { cache: "no-store" });
  if (!response.ok) {
    throw Object.assign(new Error("source-file-not-found"), {
      reason: "source-file-not-found",
      message: "静态原文件不存在",
    });
  }
  const blob = await response.blob();
  const upload = new File([blob], file.fileName || "template.docx", {
    type: blob.type || "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });

  try {
    return await createManagedTemplate({
      templateName: file.displayName || cleanTemplateName(file.fileName),
      moduleKey: file.moduleKey,
      moduleName: file.moduleName,
      submoduleKey: file.submoduleKey,
      submoduleName: file.submoduleName,
      templateType: "system",
      sourceDocumentId,
      requiresElectronicSignature: file.requiresElectronicSignature !== false,
    }, upload);
  } catch (error) {
    return recoverExistingTemplate(sourceDocumentId, error);
  }
}

export function importEditableSourceTemplate(file) {
  const sourceDocumentId = file.sourceRecordId || file.id;
  const importKey = sourceDocumentId || file.filePath;
  return runSourceImport(importKey, () => performEditableSourceImport(file));
}
